export function StatusIndicator({ status }: { status: string }) {
    const getStatusColor = (status: string) => {
        switch (status.toLowerCase()) {
            case "active":
            case "a":
                return "bg-[#079a95]";
            case "new":
            case "n":
                return "bg-[#d3d3d3]";
            case "cancelled":
            case "c":
                return "bg-[#d64545]";
            default:
                return "bg-gray-400";
        }
    };

    return <div className={`w-2 h-2 rounded-full shrink-0 ${getStatusColor(status)}`} />;
}
